import { FormListItem } from '@bn/web-ui/models';
import { ConditionMatcherEnum } from '../enums';

export const MatchItemsConfig: FormListItem[] = [
  {
    label: 'Match any',
    name: 'matchAny',
    value: ConditionMatcherEnum.MatchAny,
  },
  {
    label: 'Match all',
    name: 'matchAll',
    value: ConditionMatcherEnum.MatchAll,
  },
  {
    label: 'Match none',
    name: 'matchNone',
    value: ConditionMatcherEnum.MatchNone,
  },
];
